/*
 * @Description: 
 * @Author: ADCannon
 * @Date: 2023-01-10 16:11:16
 * @FilePath: \GamerSky.Valorant\src\assets\config\index.js
 */
function getCurrentApiRoot()
{
    var GsAppApiUrlRootDefault = "//router.gamersky.com/@";
    var gsAppApiUrlRoot = GsAppApiUrlRootDefault;
    try
    {
        gsAppApiUrlRoot = window.GSAppJsApi.Cookie.get("gsAppApiUrlRoot");
        if (gsAppApiUrlRoot != null
        && gsAppApiUrlRoot.length > 0)
        {
            if (gsAppApiUrlRoot.startsWith("http://"))
            {
                gsAppApiUrlRoot = gsAppApiUrlRoot.replace("http://", "//");
            }
            while (gsAppApiUrlRoot.endsWith("/"))
            {
                gsAppApiUrlRoot = gsAppApiUrlRoot.substring(0, gsAppApiUrlRoot.length - 1);
            }
        }
        if (gsAppApiUrlRoot == null
        || gsAppApiUrlRoot.length < 1)
        {
            gsAppApiUrlRoot = GsAppApiUrlRootDefault;
        }
    }
    catch (exception)
    {

        //
        gsAppApiUrlRoot = GsAppApiUrlRootDefault;
    }
    return gsAppApiUrlRoot;
}

const dev = {
    riotQuickBindEnabled: true,
    riotShopAccountUrl: '//router-test.gamersky.com/@133_8084',
    riotClientFetchEnabled: true,
    riotBindingPageEnabled: true,
    riotShopLoginUrl: 'https://project-test.gamersky.com/GamerSky.Valorant/shop.html',
    riotLoginScriptUrl: 'https://project-test.gamersky.com/GSAppJSApi/tests/ui.openValorantLoginDialog.js',
    baseUrl: 'https://localhost:7027',
    jsonUrlRoot: 'https://j.gamersky.com/db/valorantSkin/json',
    isApp: true,
    shareUrl: "https://www.gamersky.com/tools/valorantSkin/index.html",
    routerUrl: "//router-test.gamersky.com/@133_8084"
}
const test = {
    riotQuickBindEnabled: true,
    riotShopAccountUrl: '//router-test.gamersky.com/@133_8084',
    riotClientFetchEnabled: true,
    riotBindingPageEnabled: true,
    riotShopLoginUrl: 'https://project-test.gamersky.com/GamerSky.Valorant/shop.html',
    riotLoginScriptUrl: 'https://project-test.gamersky.com/GSAppJSApi/tests/ui.openValorantLoginDialog.js',
    baseUrl: '//router-test.gamersky.com/@valorantTracker_7083',
    riotDiagnosticsEnabled: true,
    battleFieldUrl: '//router-test.gamersky.com/@battlefield2042Tracker',
    // baseUrl: apiUrlRoot,
    // baseUrl: '/Valorant',
    jsonUrlRoot: 'https://j.gamersky.com/db/valorantSkin/json',
    isApp: true,
    shareUrl: "https://www.gamersky.com/tools/valorantSkin/index.html",
    routerUrl: getCurrentApiRoot()
}
const prod = {
    riotQuickBindEnabled: true,
    riotShopAccountUrl: getCurrentApiRoot(),
    riotClientFetchEnabled: true,
    riotBindingPageEnabled: true,
    riotShopLoginUrl: 'https://app.gamersky.com/db/valorantSkin/shop.html',
    riotLoginScriptUrl: 'https://project-test.gamersky.com/GSAppJSApi/tests/ui.openValorantLoginDialog.js',
    // baseUrl: '//gamedb2.gamersky.com/GamerSky.Valorant.Service',
    baseUrl: '//router2.gamersky.com/@valorantTracker',
    deadlockUrl: '//router4.gamersky.com/@deadlockTracker',
    battleFieldUrl: '//router2.gamersky.com/@battlefield2042Tracker',
    jsonUrlRoot: 'https://j.gamersky.com/db/valorantSkin/json',
    isApp: false,
    shareUrl: "https://www.gamersky.com/tools/valorantSkin/index.html",
    routerUrl: getCurrentApiRoot()
}
const deployEnvironment = process.env.VUE_APP_DEPLOY_ENV || (process.env.NODE_ENV === 'development' ? 'test' : 'prod');
const environmentConfig = { dev, test, prod };

export default {
    riotRouteEnabled: false,
    ...(environmentConfig[deployEnvironment] || prod),
};
